export var openInterestAnalysisLimit = 5;
export var IOpenInterestSectionType;
(function (IOpenInterestSectionType) {
    IOpenInterestSectionType["LongBuildup"] = "LongBuildup";
    IOpenInterestSectionType["LongUnwinding"] = "LongUnwinding";
    IOpenInterestSectionType["ShortCovering"] = "ShortCovering";
    IOpenInterestSectionType["ShortBuildup"] = "ShortBuildup";
})(IOpenInterestSectionType || (IOpenInterestSectionType = {}));
